import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './Extraction.css';

const Extraction = () => {
    const pricing = [
        { type: "Simple Extraction", price: "₱1,000 - ₱1,500" },
        { type: "Complicated Case", price: "₱3,500" },
    
    ];

    return (
        <>
        <Header/>
        <div className="extraction-container">
            <div className="extraction-content">
                <h1>EXTRACTION</h1>
                <p>
                Tooth extraction is a dental procedure to remove a tooth from its socket. 
                It's typically done under local anesthesia and may be necessary for various reasons, 
                including severe decay, infection, impacted teeth, trauma, gum disease, or orthodontic treatment. 
                After the extraction, it's important to follow post-operative care instructions, including managing pain, 
                swelling, and diet restrictions.
                </p>
                <h2>Pricing</h2>
                <table className="extraction-table">
                        <thead>
                            <tr>
                                <th>Type of Surgery</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pricing.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};

export default Extraction;